"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToModalProps({ data, mappers, packages, forms }) {
    let modal = null;
    if (!('blockType' in data)) {
        modal = data;
    }
    else if (data.modalReference && typeof data.modalReference === 'object') {
        modal = data.modalReference;
    }
    /**
     * TODO: This is a temporary fix to handle the hydration issue due to improper html semantics
     * this bypasses the rich text paragraph element and directly accesses the children.
     * must skip if the first element is not a typography element.
     * WARNING!! this is a temporary fix, should anything but text or button be used as a modal trigger it may have unexpected behavior.
     */
    let modalText = modal?.modalTrigger && mappers.mapRichText({ richText: modal?.modalTrigger, mappers, packages, forms });
    if (Array.isArray(modalText) && modalText.length > 0 && 'props' in modalText[0]) {
        modalText = modalText[0].type.name === 'Typography' ? modalText[0].props.children : modalText[0];
    }
    return {
        heading: modal?.heading,
        noExit: modal?.noExit,
        children: modal?.mainContent &&
            mappers.mapRichText({ richText: modal?.mainContent, mappers, packages, forms }),
        modalText
    };
}
exports.default = mapToModalProps;
